import { render, staticRenderFns } from "./DataDictionaries.vue?vue&type=template&id=0ba9efb0&scoped=true&"
import script from "./DataDictionaries.vue?vue&type=script&lang=js&"
export * from "./DataDictionaries.vue?vue&type=script&lang=js&"
import style0 from "./DataDictionaries.vue?vue&type=style&index=0&id=0ba9efb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba9efb0",
  null
  
)

export default component.exports